import request from '@/api/request'
// 上传固件
export const addFile = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/version/add',
    method: 'post',
    data: data
  })
}

// 获取模块Ota列表版本号
export const getVersion = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/version/list',
    method: 'post',
    data: data
  })
}
// 升级文件
export const updateFile = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/version/release',
    method: 'post',
    data: data
  })
}
// 查询设备OTA模块列表
export const deviceOTAmodel = (data) => {
  return request({
    url: '/v1/manager/device/ota/version/list',
    method: 'post',
    data: data
  })
}
// 查询产品OTA模块列表
export const OTAmodel = (data) => {
  return request({
    url: '/v1/manager/device/ota/module/list',
    method: 'post',
    data: data
  })
}

// 批量发布升级文件列表
export const subUpgrade = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/version',
    method: 'post',
    data: data
  })
}
// 发布产品升级文件
export const productGrade = (data) => {
  return request({
    url: '/v1/manager/user/product/ota/version',
    method: 'post',
    data: data
  })
}
// 获取升级文件列表
export const getFileUploadList = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/upgrade/list',
    method: 'post',
    data: data
  })
}
// 删除升级文件
export const deleteFileUpload = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/upgrade/delete',
    method: 'post',
    data: data
  })
}
// 查看升级文件详情
export const getFileUploadInfo = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/upgrade/get',
    method: 'post',
    data: data
  })
}

// 上传固件2
export const addFile2 = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/upgradePush',
    method: 'post',
    data: data
  })
}
// 获取上传固件列表
export const getFileUp = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/upgradeList',
    method: 'post',
    data: data
  })
}
// 添加固件升级
export const addOTAupload = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/addUpgradeEq',
    method: 'post',
    data: data
  })
}
// 删除固件升级
export const deleteUpgrade = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/DeleteFirmwareUpgrade',
    method: 'post',
    data: data
  })
}

// 获取固件升级列表
export const getUpgradeEqList = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/getUpgradeEqList',
    method: 'post',
    data: data
  })
}

// 删除上传固件
export const deleteUpgradeEq = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/deleteEqInfo',
    method: 'post',
    data: data
  })
}
// 编辑固件上传
export const updateFileUpload = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/updateEqUpload',
    method: 'post',
    data: data
  })
}
// 编辑固件升级
export const updateOTAupload = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/updateOTAupload',
    method: 'post',
    data: data
  })
}
// 批量添加常用测试设备
export const addComTesDevice = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/addComTsDevice',
    method: 'post',
    data: data
  })
}
// 批量删除常用测试设备
export const deleteComTesDevice = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/deleteComTsDevice',
    method: 'post',
    data: data
  })
}
// 获取常用测试设备号列表
export const getComTesDevice = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/getComTsDevice',
    method: 'post',
    data: data
  })
}

// 获取测试设备列表
export const getTesDeviceList = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/getTsDevice',
    method: 'post',
    data: data
  })
}

// 批量添加测试设备列表
export const addTesDeviceList = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/addTsDevice',
    method: 'post',
    data: data
  })
}

// 批量删除测试设备列表
export const deleteTesDeviceList = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/deleteTsDevice',
    method: 'post',
    data: data
  })
}

// 验证测试版本是否通过
export const validTsVersion = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/validTsVersion',
    method: 'post',
    data: data
  })
}

// 获取可升级设备总数
export const getUploadDeviceNumber = (data) => {
  return request({
    url: 'v1/manager/user/device/ota/getUpgradeDevicesNumber',
    method: 'post',
    data: data
  })
}

// 提交发布升级
export const addUpgradeReleaseRules = (data) => {
  return request({
    url: 'v1/manager/user/device/ota/EditUpgradeReleaseRules',
    method: 'post',
    data: data
  })
}

// 获取固件发布规则
export const getUpgradeReleaseRules = (data) => {
  return request({
    url: 'v1/manager/user/device/ota/GetUpgradeReleaseRules',
    method: 'post',
    data: data
  })
}

// 获取日志文件
export const getLogFile = (data) => {
  return request({
    url: '/v1/manager/user/device/logfiles',
    method: 'post',
    data: data
  })
}

// 下载日志文件
export const getLogFileByPath = (data) => {
  return request({
    url: '/v1/manager/user/device/logfiles/download',
    method: 'post',
    data: data
  })
}
